import { SVGProps } from 'react';

const CataSailingNeutral = ({
  props,
  size = 64,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#161616" rx="32" />
    <path
      fill="#888"
      d="M16.19 39.396s12.987 4.47 20.62 4.23c2.15-.07.596 4.374.596 4.374L16 39.37l.19.026Zm24.922 2.625c2.118.274 4.323.425 6.057.224 1.364-.155.638 2.757.638 2.757l-7.748-2.39a1.95 1.95 0 0 0 1.053-.591ZM29.917 16c1.977 1.164 5.385 3.483 8.176 6.564.432.488.858.994 1.26 1.51.383.505.744 1.01 1.067 1.545.647 1 1.171 2.063 1.553 3.168 1.27 3.665.654 7.271-1.803 10.717-.424.583-.908 1.032-1.482 1.327-.17.094-.363.18-.555.248-.21.076-.444.134-.674.162h-.01a4.43 4.43 0 0 1-.899.085c-3.841 0-8.455-3.684-9.404-4.875 3.447-1.623 5.615-3.875 6.453-6.697 1.107-3.745-.135-8.372-3.682-13.754Z"
    />
  </svg>
);

export default CataSailingNeutral;
